import { action, computed, makeObservable, observable } from 'mobx';

import ApiService from '../services/ApiService';

import { CustomerInvoicesSettings, InvoiceSettings } from './models/CustomerInvoicesSettings';
import { Loadable } from './models/Loadable';
import { ISsoStore } from './SsoStore';

export default class InvoiceSettingsStore {
  @observable
  public customerInvoicesSettings: Loadable<CustomerInvoicesSettings> = new Loadable<CustomerInvoicesSettings>();

  constructor(
    private apiService: ApiService,
    private ssoStore: ISsoStore
  ) {
    makeObservable(this);
  }

  @action
  public async tryLoadInvoiceSettings(): Promise<void> {
    if (!this.customerInvoicesSettings.isInitial) {
      await this.customerInvoicesSettings.promise;
      return;
    }
    const invoiceSettingsPromise = this.apiService.getInvoiceSettings(this.ssoStore.customer.customerId);
    this.customerInvoicesSettings = Loadable.toLoadable(invoiceSettingsPromise);
    await invoiceSettingsPromise;
  }

  public invoiceSettings(refNumber: string): InvoiceSettings {
    const allInvoiceSettings = this.customerInvoicesSettings.payload.invoiceSettings;
    return allInvoiceSettings.find((setting) => setting.refNumber === refNumber);
  }

  @action
  public setInvoiceSettings(refNumber: string, savedSettings: InvoiceSettings): void {
    const allInvoiceSettings = this.customerInvoicesSettings.payload.invoiceSettings;
    const refNumIndex = allInvoiceSettings.findIndex((setting) => setting.refNumber === refNumber);
    allInvoiceSettings[refNumIndex] = savedSettings;
  }

  @computed
  public get hasPaperInvoice(): boolean {
    return this.customerInvoicesSettings.payload.invoiceSettings.filter((i) => i.invoiceDeliveries.includes('POST')).length > 0;
  }

  @computed
  public get activeInvoiceSettings(): InvoiceSettings[] {
    return this.customerInvoicesSettings.payload.invoiceSettings.filter((invoiceSetting) => invoiceSetting.state !== 'READONLY');
  }
}
